// No React here: Vite plugins and module-level code read the variant at import time.
export const THEME_VARIANTS = Object.freeze({ LEGACY: 'legacy', RESKIN: 'reskin' });
export const THEME_VARIANT_STORAGE_KEY = 'branch-staff-theme-variant';

let themeVariant;

const readStoredThemeVariant = () => {
  try {
    const storedVariant = window.localStorage.getItem(THEME_VARIANT_STORAGE_KEY);
    return Object.values(THEME_VARIANTS).includes(storedVariant) ? storedVariant : THEME_VARIANTS.LEGACY;
  } catch {
    return THEME_VARIANTS.LEGACY;
  }
};

// Read once and fixed for the page load; switching saves the new variant and reloads the page.
export const getThemeVariant = () => {
  themeVariant ??= readStoredThemeVariant();
  return themeVariant;
};

// Returns false when the browser refuses the write (disabled storage, quota).
export const saveThemeVariant = (variant) => {
  try {
    window.localStorage.setItem(THEME_VARIANT_STORAGE_KEY, variant);
    return true;
  } catch {
    return false;
  }
};

// For style rules that only the reskin applies (shapes, borders, shadows): spread into a JSS rule.
export const reskinStyles = (theme, styles) => (theme.themeVariant === THEME_VARIANTS.RESKIN ? styles : {});

// Supporting actions inside cards (e.g. the sidebar's breakdown and report buttons) are outlined secondary
// buttons in the reskin so they don't compete with the screen's main action; classic keeps them filled.
export const supportingActionColor = (themeVariant) =>
  themeVariant === THEME_VARIANTS.RESKIN ? 'secondary' : 'primary';
